<template>
	<div>

    <div v-if="error" class="frm-error">{{ error_message }}</div>

    <div v-if="loading" class="col-md-12">
      <div class="loading"><img src="@/assets/img/loading.gif" alt=""></div>
    </div>
   
    <template v-else>
      <div class="ficha-extendida">
        <div class="row row-eq-height">
          <div class="col-xs-3">
            <div class="poster">
              <span class="article-recommended books-badge" :title=" $t('Recomendado') " v-if="producto.recomendado == 'S'"></span>
              <img v-if="producto.imagen" :src="producto.imagen" :class=" (producto.descatalogado) ? 'descatalogadoImg' : ''">  
            </div>
          </div>
          
          <div class="col-xs-7">
            <h1>{{ producto.titulo }}</h1>
            <div class="generos">
              <template v-for="(item, index) in producto.temas">
                <template v-if="index > 0">, </template>
                <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: item.categoria }, query: item.query }" :key="index">{{ item.nombre }}</router-link> 
              </template>
            </div>
            <div class="data">
              <span>{{ $t('Autor') }}:</span>
              <template v-for="(item, index) in producto.autores">
                <template v-if="index > 0">, </template>
                <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: item.categoria }, query: item.query }" :key="index">{{ item.nombre }}</router-link> 
              </template>
            </div>
            <div class="data"><span>{{ $t('Páginas') }}:</span> {{ producto.paginas }}</div>
            
            <div v-if="producto.editor" class="data">
              <span>{{ $t('Editor') }}:</span>
              <template v-for="(item, index) in producto.editor">
                <template v-if="index > 0">, </template>
                <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: item.categoria }, query: item.query }" :key="index">{{ item.nombre }}</router-link> 
              </template>
            </div>
            <div v-if="producto.ano" class="data"><span>{{ $t('Año de edición') }}:</span> 
              <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: producto.ano.categoria }, query: producto.ano.query }">{{ producto.ano.nombre }}</router-link>
            </div>
            <div class="data"><span>{{ $t('Fecha de lanzamiento') }}:</span> {{ (producto.salida) ? producto.salida.substr(0,10) : '' }}</div>
            <div v-if="producto.formato" class="data"><span>{{ $t('Formato') }}:</span> 
              <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: producto.formato.categoria }, query: producto.formato.query }">{{ producto.formato.nombre }}</router-link> 
            </div>
            
            <div class="data">
              <span>{{ $t('Lengua') }}:</span>
              <template v-for="(item, index) in producto.idiomas">
                <template v-if="index > 0">, </template>
                <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: item.categoria }, query: item.query }" :key="index">{{ item.nombre }}</router-link> 
              </template>
            </div>
            <div class="data"><span>{{ $t('ISBN') }}:</span> {{ producto.codigo }}</div>           
            <br>
            <div class="data"><span>{{ $t('Sinopsis') }}:</span> <div v-html="producto.sinopsis"></div></div>

          </div>

          <div class="col-xs-2">
            <div v-if="producto.descatalogado" class="descatalogado">
              <i class="fa fa-exclamation-triangle"></i>
              {{ producto.descatalogado }}
            </div>
            <div v-else class="precio">
              <div :class=" (getLoggedIn && producto.miseleccion) ? 'cantidad green right' : 'cantidad right' ">{{ toCurrency(producto.precio) }}</div>
              <div v-if=" miSeleccion "></div>
              <div v-else class="align-right">
                <div v-if="getLoggedIn && !producto.miseleccion" class="carrito">
                  <div class="mt10" v-if=" producto.miseleccion == null "><img src="@/assets/img/loading-mini.gif" ></div>
                  <button v-else class="btn mt10"
                    @click="addToSelection({ id: producto.id, ref: 'ficha_extendida', tipo: producto.tipo, con: contenedor })"><i class="fa fa-cart-arrow-down"></i> {{ $t('Seleccionar') }}</button>
                </div>
                <div v-else-if="getLoggedIn && producto.miseleccion" class="carrito">
                  <button class="btn mt10 btn-tertiary"
                    @click="removeFromSelection(producto.id)"><i class="fa fa-cart-arrow-down"></i> {{ $t('Deseleccionar') }}</button>
                </div>
                <div v-else class="carrito">
                  <button class="btn mt10"
                    @click="showLoginModal"><i class="fa fa-cart-arrow-down"></i>  {{ $t('Seleccionar') }}</button>
                </div>
              </div> 
                
            </div>
          </div>

        </div>
      </div>
    </template>
  </div>
</template>

<i18n>
{
  "es": {
    "Autor": "Autor",
    "Páginas": "Páginas",
    "Editor": "Editor",
    "Formato": "Formato",
    "Lengua": "Lengua",
    "Año de edición": "Año de edición",
    "Fecha de lanzamiento": "Fecha de lanzamiento",
    "ISBN": "ISBN",
    "Sinopsis": "Sinopsis",
    "Seleccionar": "Seleccionar",
    "Deseleccionar": "Deseleccionar"
  },
  "en": {
   
  },
  "ca": {
    "Autor": "Autor",
    "Páginas": "Pàgines",
    "Editor": "Editor",
    "Formato": "Format",
    "Lengua": "Llengua",
    "Año de edición": "Any d'edició",
    "Fecha de lanzamiento": "Data de llançament",
    "ISBN": "ISBN",
    "Sinopsis": "Sinopsi",
    "Seleccionar": "Seleccionar",
    "Deseleccionar": "Deseleccionar"
  }
}
</i18n>

<script>
  import axios from 'axios';
  import { mapGetters } from 'vuex';

	export default {
    props:['productID', 'miSeleccion', 'contenedor'],
		data: () => {
			return{
        producto: "",
        loading: false,
        error: false,
        error_message: ''
			}
		},
    mounted(){
      this.cargarProducto(this.getLocale);
    },
    computed: mapGetters(['getLocale', 'getApiUrl', 'getSelectionBus', 'getLoggedIn', 'getReloadContent']),
    methods:{
      cargarProducto(idioma){
        this.showLoading();
        let contenedorQuery = (this.contenedor) ? '&con=' + this.contenedor : '';
        axios.get(this.getApiUrl + this.getLocale + '/libros?id=' + this.productID + contenedorQuery)
          .then( (respuesta) =>{   
            this.producto = respuesta.data.data.resultados[0];
            //this.$store.commit('setFichaExtendidaSelected', this.producto.miseleccion);
            this.hideLoading(); 
          })
          .catch( (error) =>{ 
            this.error_message = error.response.data.status + ' ' + error.response.data.msg;
            this.error = true;
            this.hideLoading();      
          })        
      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
      addToSelection(obj){ this.$store.dispatch('addToSelection', obj); },
      removeFromSelection(id){ this.$store.dispatch('removeFromSelection', id); },
      showLoginModal(){ this.$store.commit('showModalLogin'); }
    },
    watch:{
      getSelectionBus: function(){
        if( !(Object.keys(this.getSelectionBus).length === 0) && !(this.getSelectionBus === Object) ){ 
          if( !(Object.keys(this.producto).length === 0) && !(this.producto === Object) ){
            let id = this.getSelectionBus.id;
            if( this.producto.id == this.getSelectionBus.id ){
              this.producto.miseleccion = this.getSelectionBus.miseleccion;
            }
          }
        }
      },
      getReloadContent: function(newValue){
        if(newValue){
          this.cargarProducto();
        }
      },
    }
  }
</script>
